/*
 * @Author: Teemo Ding
 * @Date: 2021-08-11 11:24:24
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-10-18 13:10:57
 * @FilePath: /unifyxp-v2-store-portal/src/request/customer/customerDetail.ts
 */
import { get, post, remove } from 'src/tools/server';
/**
 *  customer
 */

export const request_customerDetailList = (customerUuid) => {
  return get<any>(`/portal/customer/detail/${customerUuid}`, {});
};

export const request_saveCustomerDetail = (data) => {
  return post<any>(`/portal/customer/detail`, data, {
    returnWholeData: true,
    handleErrorAsResolve: true,
  });
};

export const request_saveRemarkTag = (data) => {
  return post<any>(`/portal/customer/detail/remarkTag`, data, {});
};

export const request_saveCustomerInfo = (data) => {
  return post<any>(`/portal/customer/detail`, data, {
    returnWholeData: true,
    handleErrorAsResolve: true,
  });
};

export const request_deleteCustomer = (customerUuid) => {
  return remove<any>(`/portal/customer/${customerUuid}`, {});
};

export const request_addCustomerComment = (data) => {
  return post<any>(`/portal/customer/detail/comment`, data, {});
};

export const request_deleteCustomerComment = (customerUuid, commentUuid) => {
  return remove<any>(
    `/portal/customer/${customerUuid}/detail/comment/${commentUuid}`,
    {},
  );
};

export const request_addSubscription = (customerUuid) => {
  return post<any>(`/portal/customer/${customerUuid}/subscribe`, {}, {});
};

export const request_deleteSubscription = (subscriptionUuid) => {
  return remove<any>(`/portal/customer/subscription/${subscriptionUuid}`, {});
};

export const request_allSalesChannels = (customerDBUuid) => {
  return get<any>(`/portal/customer/${customerDBUuid}/allSalesChannels`, {});
};

export const request_sendInvitation = (data) => {
  return post<any>(`/portal/customer/detail/sendInvitation`, data, {});
};

/**
 *  subscriber
 */

export const request_subscriberDetailList = (subscriberUuid) => {
  return get<any>(`/portal/subscriber/${subscriberUuid}`, {});
};

export const request_deleteSubscriber = (subscriberUuid) => {
  return remove<any>(`/portal/subscriber/${subscriberUuid}`, {});
};

export const request_addSubscriberComment = (subscriberUuid, data) => {
  return post<any>(`/portal/subscriber/comment/${subscriberUuid}`, data, {});
};

export const request_deleteSubscriberComment = (subscriberUuid, uuid) => {
  return remove<any>(
    `/portal/subscriber/comment/${subscriberUuid}/${uuid}`,
    {},
  );
};
export const request_saveSubscriberDetail = (data) => {
  return post<any>(`portal/subscriber/detail`, data, {});
};

export const request_info = (data) => {
  return post<any>(`portal/subscriber`, data, {
    returnWholeData: true,
    handleErrorAsResolve: true,
  });
};
